'use strict';
import { app } from '../../../../../../../bootstrap/core';
import QrMismatchService from './qrMismatch.service';

import qrMismatchComponent from './qrMismatch.component';

app.component('qrMismatchComponent', qrMismatchComponent);
app.service('qrMismatchService', QrMismatchService);
